import KazaNotifications from './_notifications';

export default class ProductVariations {

	constructor( options ) {
		const myself = this;
		this.thumbnailSlider = this.ThumbmailSlider;
		this.productSlider = this.ProductSlider;

		this.debug = options.debug ? options.debug : false;
		this.form = document.querySelector( '.variations_form' );
		this.variationData = this.VariationsData;
		this.bestVariation = this.BestSellerVariation;
		this.colorSwiper = this.ColorSwiper;
		this.variationLoader = document.querySelector( '.js-loader--variation' );
		this.quantityBtns = document.querySelector( '.variations__quantity' );
		this.stockByDate = document.querySelector( '.stock_by_date' );
		this.quantity = this.form.quantity;
		this.priceTag = document.querySelector( '.product__price' );
		this.addToCartBtn = document.querySelector( '.add-to-cart-btn' );
		this.variation = {};
		this.timer;
		this.selectedColor = '';
		this.changeColor = false;
		this.firstLoad = true;
		this.vat = 1.18;
		this.hasStockIssues = false;
		this.isAddingToCart = false;

		this.InitProductInfo();
		this.UpdateProductInfo( this.bestVariation );

		/*this.fbq = {
			AddToCart: {}
		};*/

		this.gtag = {
			conversion: {
				send_to: 'AW-623203107/aNJrCMfcnewBEKOmlakC',
				items: []
			}
		};

		setTimeout( () => {
			jQuery( '.product__thumbnails-container' ).show();
			this.AddThumbnailSlides( this.bestVariation.gallery );
		}, 100 );
		setTimeout( () => {
			this.AddProductSlides( this.bestVariation.gallery );
		}, 100 );

		jQuery( this.quantity ).on( 'change', ( event ) => {
			this.stockByDate.style.opacity = .5;
			this.addToCartBtn.classList.add( 'disabled' );
			this.addToCartBtn.style.setProperty( 'pointer-events', 'none', 'important' );
			this.quantityBtns.classList.add( 'not-clickable' );
			this.UpdateProductStock( this.variation );
		});

		jQuery('.quantity').attr('data-counter', 1);

		jQuery( document ).on( 'click', '.quantity .plus', ( event ) => {
			let counter = parseInt( jQuery('.quantity').attr('data-counter') );
			counter++;
			jQuery('.quantity').attr('data-counter', counter);
		});

		jQuery( document ).on( 'click', '.quantity .minus', ( event ) => {
			let counter = parseInt( jQuery('.quantity').attr('data-counter') );
			if ( counter > 1 ) {
				counter--;
			}
			jQuery('.quantity').attr( 'data-counter', counter );
		});

		jQuery( this.form ).on( 'update_variation_values', ( event ) => {
			setTimeout( () => {
				if ( this.changeColor ) {
					this.changeColor = false;
					jQuery( '#pa_color' ).val( this.selectedColor );
					jQuery( '#pa_color' ).trigger( 'change' );
				}
				this.stockByDate.style.opacity = .5;
				this.addToCartBtn.classList.add( 'disabled' );
				this.addToCartBtn.style.setProperty( 'pointer-events', 'none', 'important' );

				if (this.variationData) {
					let notSale = document.querySelector('.product__not-sale');
					if (notSale) {
						this.variationData.map((variation) => {
							if (this.variation.variation_id === variation.variation_id) {
								this.addToCartBtn.style.display = variation.is_not_for_sale ? 'none' : 'flex';
								notSale.style.display = variation.is_not_for_sale ? 'block' : 'none';
							}
						});
					}
				}
			}, 200 );
		});

		jQuery( this.form ).on( 'found_variation', ( event, variation ) => {
			myself.quantity.max = variation.max_qty;
			myself.variation = variation;
			myself.UpdateProductStock( variation );
			myself.UpdateProductInfo( variation );
			myself.SyncUrlWithVariation( variation );

			if ( variation.gallery && myself.variationData.length > 1 ) {
				setTimeout( () => {
					myself.AddProductSlides( variation.gallery );
				}, 100 );
				setTimeout( () => {
					myself.AddThumbnailSlides( variation.gallery );
				}, 100 );
			}

			/*myself.fbq.AddToCart = {
				content_type: 'product',
				currency: 'ILS',
				content_ids: [variation.sku],
				content_name: variation.name,
				content_category: variation.category,
				value: variation.display_price
			};*/

			myself.gtag.conversion.items.push({
				currency: 'ILS',
				id: variation.sku,
				category_name: variation.category,
				category_id: variation.category_id,
				value: variation.display_price
			});
		});

		jQuery( '.variations__btns' ).on( 'click', 'a', function() {
			myself.VariationBlock();
		});

		jQuery( '.redirect' ).on( 'change', function() {
			myself.VariationBlock();
			location.replace( this.value );
		});

		jQuery('.add-to-cart-btn').on('click', function(e){
			// Always prevent default to avoid full page reload; we'll handle AJAX add-to-cart.
			e.preventDefault();
			e.stopPropagation();
			// Block submission if button is disabled or has stock issues.
			if ( myself.addToCartBtn.classList.contains('disabled') || myself.hasStockIssues || myself.isAddingToCart ) {
				return false;
			}

			// Get current quantity
			let currentQuantity = parseInt( jQuery('.quantity').attr('data-counter') ) || 1;

			// Check stock right before adding to cart
			myself.CheckStockBeforeAdding( myself.variation, currentQuantity, function(canAdd, actualQuantity) {
				if (canAdd) {
					// Update quantity fields then perform explicit AJAX add-to-cart to avoid page reload.
					jQuery('.quantity .qty').val(actualQuantity);
					jQuery('.quantity').attr('data-counter', actualQuantity);
					myself.AddToCartAjax( myself.variation, actualQuantity );
					//fbq('track', 'AddToCart', myself.fbq.AddToCart);
					gtag('event', 'conversion', myself.gtag.conversion);
				} else {
					// Prevent form submission and show error.
					jQuery('.variations__quantity').after('<p class="stock-info error">אין אפשרות להוסיף מוצר זה - חרגת מהמגבלות</p>');
				}
			});
		});

		this.VariationUnblock();
	}

	get VariationsData() {
		let data = JSON.parse( this.form.dataset.product_variations );
		let newData = [];
		for ( const key in data ) {
			if ( data.hasOwnProperty( key ) ) {
				const element = data[key];
				newData.push( element );
			}
		}
		return newData;
	}

	get ActiveColorSlide() {
		let active = jQuery( 'img.variations__image[data-activeColor]' ).attr( 'data-activeColor' );
		let length = jQuery( 'img.variations__image' ).length;
		active = ( length * -1 ) + active;
		return active;
	}

	get BestSellerVariation() {
		if ( this.debug ) {
			console.log( this.variationData );
		}
		let bestVariationID = this.variationData.filter( el => '' != el.best_variation_id );
		bestVariationID =  bestVariationID[0].best_variation_id;
		let bestVariation = this.variationData.filter( el => el.variation_id == bestVariationID );
		if ( this.debug ) {
			console.info( 'best seller variation', bestVariation[ 0 ]);
		}
		return bestVariation[ 0 ] || this.variationData[0];
	}

	VariationBlock() {
		this.priceTag.style.opacity = .25;
		this.variationLoader.style.visibility = 'visible';
		this.variationLoader.style.opacity = 1;
	}

	VariationUnblock() {
		this.variationLoader.style.visibility = 'hidden';
		this.variationLoader.style.opacity = 0;
	}

	set price( val ) {
		this.priceTag.innerHTML = val;
	}

	set message( val ) {
		this.stockByDate.innerHTML = val;
	}

	get stock() {
		let quantity = this.quantity.value;
		if ( this.debug ) {
			console.info( 'user stock quantity', quantity );
		}
		return quantity;
	}

	AddComaSeparetor( num ) {
		if (typeof num !== 'undefined') {
			num = num.toLocaleString( 'en-US', { maximumFractionDigits: 2 } );

			let substr  = num.split( '.' );
			let intVal  = String( substr[0] );
			let decimal = substr[1] !== undefined ? String( substr[1] ) : false;

			if ( decimal.length === 1 ) {
				decimal = decimal + '0';
			}

			//num = decimal ? intVal + '<sup>' + decimal + '</sup>' : intVal;

			return intVal;
		}
		return String( 0 );
	}

	UpdateProductStock( variation ) {
		if (this.debug) {
			console.info('action start UpdateProductStock');
		}
		const self = this;

		if ( this.xhrUpdateProductStock ) {
			this.xhrUpdateProductStock.abort();
		}
		this.xhrUpdateProductStock = jQuery.ajax({
			url: kaza_ajax.url,
			data: {
				action: 'update_product_stock',
				nonce_code: kaza_ajax.nonce,
				variation: variation.variation_id
			},
			type: 'POST',
			beforeSend: function() {
				self.CheckIsSimpleProduct( variation, self );
			},
			success: function( res ) {
				self.CheckStock( variation );
			}
		});

		if ( this.debug ) {
			console.info( 'action end UpdateProductStock' );
		}
	}

	CheckStock( variation ) {
		if ( this.debug ) {
			console.info( 'action start CheckStock' );
		}
		const self = this;
		if ( this.xhrCheckStock ) {
			this.xhrCheckStock.abort();
		}

		this.xhrCheckStock = jQuery.ajax({
			url: kaza_ajax.url,
			data: {
				action: 'kaza_check_product_stock',
				nonce_code: kaza_ajax.nonce,
				variation: variation.variation_id,
				stock: self.stock
			},
			type: 'POST',
			success: function( res ) {
				if ( res.success ) {
					// Check if there's a quantity limitation warning in the response
					let hasQuantityLimitError = false;
					if ( res.data && res.data.custom_availability && res.data.custom_availability.includes('אזל במלאי') ) {
						hasQuantityLimitError = true;
					}

					// update qty / stock-info as before
					let date = new Date( Date.now() );
					let dateString = date.getFullYear();
					dateString += '-';
					dateString += 10 > date.getMonth() + 1 ? '0' + ( date.getMonth() + 1 ) : date.getMonth + 1;
					dateString += '-';
					dateString += 10 > date.getDate() ? '0' + date.getDate() : date.getDate();

					let stockByDate = res.data.stock_by_date;
					let niceDate    = stockByDate ? stockByDate.replace( /-/g, '/' ) : '';
					let qtyRequest  = parseInt( jQuery('.quantity').attr('data-counter') );
					let qtyResponse = parseInt( res.data.stock_count );

					if ( jQuery('.stock-info').length > 0 ) {
						jQuery('.stock-info').remove();
					}

					if ( jQuery('.quantity .qty').length > 0 ) {
						jQuery('.quantity .qty').attr( 'max', qtyResponse );
					}

					// Adjust quantity if it exceeds available stock
					if ( qtyResponse < qtyRequest ) {
						jQuery('.quantity').attr('data-counter', qtyResponse);
						jQuery('.variations__quantity').after('<p class="stock-info">נותרו ' + qtyResponse + ' פריטים במלאי</p>');
					}

					// Enable add to cart button only if there's stock available
					if ( qtyResponse > 0 && !hasQuantityLimitError ) {
						self.addToCartBtn.classList.remove( 'disabled' );
						self.addToCartBtn.style.removeProperty( 'pointer-events' );
						self.hasStockIssues = false;
					} else {
						self.addToCartBtn.classList.add( 'disabled' );
						self.addToCartBtn.style.setProperty( 'pointer-events', 'none', 'important' );
						self.hasStockIssues = true;
					}

					// If server sent custom_availability (variation has property 55), prefer it
					if ( res.data.custom_availability ) {
						// use server-provided exact string
						self.message = res.data.custom_availability;
					} else {
						if ( dateString == stockByDate ) {
				 			self.message = 'זמין להספקה מיידית';
						} else {
							self.message = `זמן אספקה משוער בתאריך ${niceDate}`;
						}
					}
				} else {
					// If no stock available, disable button
					self.addToCartBtn.classList.add( 'disabled' );
					self.addToCartBtn.style.setProperty( 'pointer-events', 'none', 'important' );
					self.hasStockIssues = true;
				}
			},
			complete: function() {
				// Only enable button if stock check was successful
				if ( !self.hasStockIssues ) {
					self.addToCartBtn.classList.remove( 'disabled' );
					self.addToCartBtn.style.removeProperty( 'pointer-events' );
				}
				self.quantityBtns.classList.remove( 'not-clickable' );
				self.stockByDate.style.opacity = 1;

				// Reset stock issues flag
				self.hasStockIssues = false;
			}
		});
		if ( this.debug ) {
			console.info( 'action end CheckStock' );
		}
	}

	InitProductInfo() {
		this.title = document.querySelector( '.product__title-text' );
		this.shortDescription = document.querySelector( '.product__short-description' );
		this.technikalDescriptionContent = document.querySelector( '.tabs__info span' );
		this.listTechnikalDescription = document.querySelector( '.tabs__list' );
		this.longDescription = document.querySelector( '.tabs__description' );

		this.title.textContent = this.bestVariation.name;
		this.shortDescription.textContent = this.CropQuotesOnString( this.bestVariation.short_description );
		this.longDescription.innerHTML = this.bestVariation.long_description ? this.CropQuotesOnString( this.bestVariation.long_description ) : 'אין תיאור';
		this.technikalDescriptionContent.innerHTML = '<strong>מפרט טכני: </strong>' + this.bestVariation.technical_description ? this.CropQuotesOnString( this.bestVariation.technical_description ) : 'אין תיאור';
		if ( this.form?.attribute_pa_size ) {
			this.CreateProductDimentions( this.bestVariation );
		}
	}

	CreateProductDimentions(data) {
		if (!data || !data.attributes) {
			console.warn("No attributes in variation data:", data);
			return;
		}

		const size = data.attributes.attribute_pa_size || '';
		let dimentions = size.replace(/-/g, '.').split('x');

		let extraSize = data.rgbc_extra_size;

		if (dimentions[0]) {
			let depth = document.createElement('li');
			depth.innerHTML = `<strong>עומק כללי (ס”מ): </strong> ${dimentions[0]}`;
			this.listTechnikalDescription.appendChild(depth);
		}

		if (dimentions[1]) {
			let height = document.createElement('li');
			height.innerHTML = `<strong>גובה כללי (ס”מ): </strong> ${dimentions[1]}`;
			this.listTechnikalDescription.appendChild(height);
		}

		if (dimentions[2]) {
			let width = document.createElement('li');
			width.innerHTML = `<strong>רוחב כללי (ס”מ): </strong> ${dimentions[2]}`;
			this.listTechnikalDescription.appendChild(width);
		}

		if (extraSize) {
			let extra = document.createElement('li');
			extra.innerHTML = `<strong>${extraSize[1]}: </strong> ${extraSize[0]}`;
			this.listTechnikalDescription.appendChild(extra);
		}

		if (data.sku) {
			let sku = document.createElement('li');
			sku.innerHTML = `<strong>מק"ט: </strong> ${data.sku}`;
			this.listTechnikalDescription.appendChild(sku);
		}

		if (data.country) {
			let country = document.createElement('li');
			country.innerHTML = `<strong>ארץ ייצור: </strong> ${data.country}`;
			this.listTechnikalDescription.appendChild(country);
		}

		let colors = document.createElement('li');
		colors.innerHTML = `* יתן שינוי בהצגת גוון הפריט בהתאם לסוג המסך`;
		this.listTechnikalDescription.appendChild(colors);

		let sizes = document.createElement('li');
		sizes.innerHTML = `* תיתכן סטייה של עד 2% במידות המצויינות`;
		this.listTechnikalDescription.appendChild(sizes);
	}

	CreateProductDimentionsOption(data) {
		if (!data || typeof data !== 'string') {
			console.warn("Invalid dimension data:", data);
			return 'מידות לא זמינות';
		}

		let dimentions = data.replace(/-/g, '.').split('x');
		let buf = '';

		if (dimentions[0]) {
			buf += `עומק ${dimentions[0]} `;
		}

		if (dimentions[1]) {
			buf += `/ גובה ${dimentions[1]} `;
		}

		if (dimentions[2]) {
			buf += `/ רוחב ${dimentions[2]} `;
		}

		return buf || 'מידות לא זמינות';
	}

	UpdateProductInfo( data ) {
		this.title.textContent = this.CropQuotesOnString( data.name );
		this.shortDescription.textContent = this.CropQuotesOnString( data.short_description );
		this.longDescription.innerHTML = this.CropQuotesOnString( data.long_description );
		this.technikalDescriptionContent.innerHTML = '<strong>מפרט טכני: </strong>' + this.CropQuotesOnString( data.technical_description );
		this.listTechnikalDescription.innerHTML = '';
		if ( this.form.attribute_pa_size ) {
			this.CreateProductDimentions( data );
		}
	}

	CropQuotesOnString( string ) {
		if (typeof string !== 'string') {
			return '';
		}
		return string.slice(0, string.length);
	}

	get ColorSwiper() {
		const myself = this;

		let container = document.querySelector( '.variations__color' );

		if (!container) {
			return false;
		}
		let slides = container.querySelectorAll( '.variations__slide' );
		if ( 3 < slides.length ) {

			let s = new Swiper( '.variations__color', {
				slidesPerView: 3,
				lazy: {
					elementClass: 'variations__image'
				},
				navigation: {
					nextEl: '.variations__button--next',
					prevEl: '.variations__button--prev'
				},
				spaceBetween: 2,
				allowTouchMove: false,
				on: {
					click: function( event ) {
						for ( let i = 0; i < this.slides.length; i++ ) {
							const slide = this.slides[ i ];
							slide.classList.remove( 'selected' );
						}
						this.clickedSlide.classList.add( 'selected' );
						let selectedColor = this.clickedSlide.querySelector( 'img' ).getAttribute( 'data-color' );
						myself.selectedColor = selectedColor;
						myself.changeColor = true;

						// This block was commented out because the update_variation_value event was triggered multiple times on the iphone, as a result, the stack overflowed, also lines #450, #470
						// jQuery( '.reset_variations' ).click();

						jQuery( myself.form ).trigger( 'update_variation_values' );
					}
				}
			});

			setTimeout( () => {
				s.slideTo( this.ActiveColorSlide, 0 );
			}, 500 );

			return s;
		} else {
			let params = new URL(window.location);
			let search = new URLSearchParams(params.search);

			if ( ! search.has('attribute_pa_color') && jQuery('.variations__slide').length == 1) {
				setTimeout(() => {
					for ( let i = 0; i < slides.length; i++ ) {
						const slide = slides[ i ];
						slide.classList.remove( 'selected' );
					}
					jQuery('.variations__slide')[0].classList.add( 'selected' );
					let selectedColor = jQuery('.variations__slide')[0].querySelector( 'img' ).getAttribute( 'data-color' );
					myself.selectedColor = selectedColor;
					// jQuery( '.reset_variations' ).trigger( 'click' );
					myself.changeColor = true;
					jQuery( myself.form ).trigger( 'update_variation_values' );
				}, 1000);
			}

			jQuery( container ).on( 'click', '.variations__slide', function( event ) {
				for ( let i = 0; i < slides.length; i++ ) {
					const slide = slides[ i ];
					slide.classList.remove( 'selected' );
				}
				this.classList.add( 'selected' );
				let selectedColor = this.querySelector( 'img' ).getAttribute( 'data-color' );
				myself.selectedColor = selectedColor;
				// jQuery( '.reset_variations' ).trigger( 'click' );
				myself.changeColor = true;
				jQuery( myself.form ).trigger( 'update_variation_values' );
			});

			return false;
		}
	}

	AddProductSlides(data) {
		if (!Array.isArray(data) || data.length === 0) {
			if (this.debug) console.warn('No product slides data:', data);
			return;
		}

		this.productSlider.removeAllSlides();

		for (const element of data) {
			let imgSrc = element?.collection__img5 || element?.full || '';
			if (!imgSrc) continue; // пропускаем, если нет картинки

			let imgSlider = document.createElement('img');
			imgSlider.classList.add('product__slider-img');
			imgSlider.setAttribute('data-src', imgSrc);

			let preloaderSlider = document.createElement('div');
			preloaderSlider.classList.add('swiper-lazy-preloader');

			let slideSlider = document.createElement('div');
			slideSlider.classList.add('product__slider-slide', 'swiper-slide');
			slideSlider.appendChild(imgSlider);
			slideSlider.appendChild(preloaderSlider);

			this.productSlider.appendSlide(slideSlider);

			if (this.debug) console.log('productSlideAdded');
			this.productSlider.update();
		}

		this.productSlider.lazy.load();
		this.productSlider.slideTo(0, 0);

		if (kaza_ajax.is_outlet_product === '1') {
			data.forEach((image, index) => {
				if (image?.is_outlet_thumbnail) {
					this.productSlider.slideTo(index, 0);
				}
			});
		}
	}

	AddThumbnailSlides(data) {
		if (!Array.isArray(data) || data.length === 0) {
			if (this.debug) console.warn('No thumbnail slides data:', data);
			return;
		}

		this.thumbnailSlider.removeAllSlides();
		let first = true;

		for (const element of data) {
			let imgSrc = element?.thumb || '';
			if (!imgSrc) continue; // пропускаем, если нет картинки

			let imgThumbnail = document.createElement('img');
			imgThumbnail.classList.add('product__thumbnail-img');
			imgThumbnail.setAttribute('data-src', imgSrc);

			let preloaderSlider = document.createElement('div');
			preloaderSlider.classList.add('swiper-lazy-preloader');

			let slideThumbnail = document.createElement('div');
			if (first) {
				slideThumbnail.classList.add('swiper-slide-thumb-active');
				first = false;
			}
			slideThumbnail.classList.add('product__thumbnail-slide', 'swiper-slide');
			slideThumbnail.appendChild(imgThumbnail);
			slideThumbnail.appendChild(preloaderSlider);

			this.thumbnailSlider.appendSlide(slideThumbnail);

			if (this.debug) console.log('thumbSlideAdded');
			this.thumbnailSlider.update();
		}

		this.thumbnailSlider.lazy.load();
		this.thumbnailSlider.slideTo(0, 0);

		if (kaza_ajax.is_outlet_product === '1') {
			data.forEach((image, index) => {
				if (image?.is_outlet_thumbnail) {
					this.thumbnailSlider.slideTo(index, 0);
				}
			});
		}
	}

	get ThumbmailSlider() {
		return new Swiper( '.product__thumbnails-swiper', {
			slidesPerView: 4,
			initialSlide: 1,
			freeModeSticky: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			lazy: {
				elementClass: 'product__thumbnail-img'
			},
			navigation: {
				nextEl: '.product__thumbnails-button--next',
				prevEl: '.product__thumbnails-button--prev'
			},
			spaceBetween: 2,
			allowTouchMove: false
		});
	}

	get ProductSlider() {
		let self = this;
		let container = document.querySelector( '.product__swiper' );
		container.className = 'product__swiper swiper-container';
		let s = new Swiper( '.product__swiper', {
			slidesPerView: 1,
			pagination: {
				el: '.product__dots',
				type: 'bullets'
			},
			lazy: {
				elementClass: 'product__slider-img'
			},
			thumbs: {
				swiper: self.thumbnailSlider
			}
		});
		return s;
	}

	CheckIsSimpleProduct( variation, self ) {
		if (self.priceTag) {
			self.priceTag.style.opacity = .25;
		}

		//NEW TYPE OF PRODUCT (Prprty 14)
		jQuery.ajax({
			url: kaza_ajax.url,
			data: {
				action: 'check_is_simple_product',
				nonce_code: kaza_ajax.nonce,
				variation: variation.variation_id
			},
			type: 'POST',
			success: function (res) {
				if (self.priceTag && res.layout ) {
					self.priceTag.innerHTML = res.layout;
					self.priceTag.style.opacity = 1;
				}
			}
		});
	}

	/**
	 * Check stock before adding to cart - final verification.
	 */
	CheckStockBeforeAdding( variation, requestedQuantity, callback ) {
		if (this.debug) {
			console.info('action start CheckStockBeforeAdding');
		}

		jQuery.ajax({
			url: kaza_ajax.url,
			data: {
				action: 'kaza_check_product_stock',
				nonce_code: kaza_ajax.nonce,
				variation: variation.variation_id,
				stock: requestedQuantity
			},
			type: 'POST',
			success: function( res ) {
				let canAdd = false;
				let actualQuantity = requestedQuantity;

				if ( res.success && res.data ) {
					let stockCount = parseInt( res.data.stock_count ) || 0;
					let hasQuantityLimitError = res.data.custom_availability && res.data.custom_availability.includes('אזל במלאי');

					if ( stockCount > 0 && !hasQuantityLimitError ) {
						// Can add, but adjust quantity to available stock
						actualQuantity = Math.min( requestedQuantity, stockCount );
						canAdd = true;
					}
				}

				if (callback && typeof callback === 'function') {
					callback(canAdd, actualQuantity);
				}

				if (this.debug) {
					console.info('CheckStockBeforeAdding result:', { canAdd, actualQuantity, requestedQuantity });
				}
			}.bind(this),
			error: function() {
				if (callback && typeof callback === 'function') {
					callback(false, 0);
				}
			}
		});

		if (this.debug) {
			console.info('action end CheckStockBeforeAdding');
		}
	}

	/**
	 * Perform explicit WooCommerce AJAX add-to-cart to avoid page reload and refresh mini-cart.
	 */
	AddToCartAjax( variation, quantity ) {
		if ( this.isAddingToCart ) {
			return;
		}

		this.isAddingToCart = true;
		const $button = jQuery( this.addToCartBtn );
		$button.addClass( 'loading' );

		const productId = this.form?.dataset?.product_id || '';
		const variationId = variation?.variation_id || '';
		const formAction = (this.form && this.form.getAttribute('action')) || window.location.href;
		const formData = jQuery(this.form).serializeArray();

		// Update quantity and product_id to variation_id for proper WooCommerce handling
		let quantityFound = false;
		let productIdFound = false;

		for (let i = 0; i < formData.length; i++) {
			if (formData[i].name === 'quantity') {
				formData[i].value = quantity;
				quantityFound = true;
			}
			if (formData[i].name === 'product_id') {
				formData[i].value = variationId || productId;
				productIdFound = true;
			}
		}

		// Add missing required fields
		if (!quantityFound) {
			formData.push({ name: 'quantity', value: quantity });
		}
		if (!productIdFound && variationId) {
			formData.push({ name: 'product_id', value: variationId });
		}

		if (this.debug) {
			console.log('AddToCartAjax formData:', formData);
			console.log('Sending product_id (variation):', variationId || productId);
		}

		// Build wc-ajax URL
		const ajaxUrl = (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.wc_ajax_url)
			? wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart')
			: formAction;

		jQuery.ajax({
			url: ajaxUrl,
			type: 'POST',
			data: formData,
			success: function(response) {
				if (this.debug) {
					console.log('AddToCartAjax success:', response);
				}

				if (response && response.error) {
					if (response.product_url) {
						window.location = response.product_url;
					}
					return;
				}

				$button.data('kaza-notified', true);
				window.setTimeout(function() {
					$button.removeData('kaza-notified');
				}, 200);

				KazaNotifications.showAddToCartNotification({
					product_name: this.title ? this.title.textContent.trim() : '',
					quantity: quantity,
					fragments: response && response.fragments ? response.fragments : null,
				});

				// Refresh cart fragments to update mini-cart UI.
				jQuery(document.body).trigger('wc_fragment_refresh');
			}.bind(this),
			error: function(xhr, status, error) {
				if (this.debug) {
					console.error('AddToCartAjax error:', error);
				}
				// Fallback: try normal fragment refresh to keep UI in sync.
				jQuery(document.body).trigger('wc_fragment_refresh');
			}.bind(this),
			complete: function() {
				this.isAddingToCart = false;
				$button.removeClass('loading');
			}.bind(this)
		});
	}

	SyncUrlWithVariation( variation ) {
		if ( ! document.body.classList.contains( 'single-product' ) ) {
			return;
		}
		if ( ! variation || ! variation.attributes ) {
			return;
		}

		const url = new URL( window.location.href );

		Object.keys( variation.attributes ).forEach( ( key ) => {
			if ( key.indexOf( 'attribute_' ) !== 0 ) {
				return;
			}
			const rawValue = variation.attributes[ key ];
			if ( rawValue ) {
				let decoded = rawValue;
				try {
					decoded = decodeURIComponent( rawValue );
				} catch ( e ) {
					decoded = rawValue;
				}
				url.searchParams.set( key, decoded );
			} else {
				url.searchParams.delete( key );
			}
		} );

		window.history.replaceState( null, '', url.toString() );
	}
}
